'use strict';

/** Web client OAuth ID — must match Google Cloud Console authorized origins. */
module.exports = '1082876692474-4f1n956n709jtmufln04rjbnl09fqlni.apps.googleusercontent.com';
